import { injectIntl } from "react-intl";
import { connect } from "react-redux";

import LanguageSelector from "./LanguageSelector";
import { post, get } from "../../../actions/general";

const mapDispatchToProps = {
    post,
    get,
};

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(LanguageSelector));
